/* LIST OF TEALIUM CONSTANTS */
export const tealiumConstants = {
    page_type: 'page_type',
    page_name: 'page_name',
    page_url: 'page_url',
    funnel_name: 'funnel_name',
    funnel_step: 'funnel_step',
    funnel_step_name: 'funnel_step_name',
    form_field_1: 'form_field_1',
    form_field_2: 'form_field_2',
    product_offered: 'product_offered',
    product_id: 'product_id',
    product_category: 'product_category',
    product_subcategory: 'product_subcategory',
    application_id: 'application_id',
    internal_reference_id: 'internal_reference_id',
    event_category: 'event_category',
    event_action: 'event_action',
    event_content: 'event_content',
    page_customer_group: 'page_customer_group',
    promotion_content: 'promotion_content',
    promotion_event: 'promotion_event',
    click_event: 'click_event',
    page_language: 'page_language',
    page_security_level: 'page_security_level',
    page_business_line: 'page_business_line',
    customer_group: 'customer_group',
    site_section: 'site_section',
    site_type: 'site_type',
    page_category: 'page_category',
    page_subcategory: 'page_subcategory',
  }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/utitlity/tealium.constants.ts